export type SortingDivider = 'Before' | 'After';

export const SortingDivider = {
  Before: 'Before' as SortingDivider,
  After: 'After' as SortingDivider
}